// @flow
import { nthArg } from "ramda"

import { getCSRFCookie } from "../api"

import type { QueryState } from "redux-query-react/src/types.js"

// replace the previous state with the next state without merging
export const nextState = nthArg(1)

export const hasUnauthorizedResponse = (queryState: ?QueryState) =>
  queryState &&
  queryState.isFinished &&
  (queryState.status === 401 || queryState.status === 403)

export const getCsrfOptions = () => ({
  headers: {
    "X-CSRFTOKEN": getCSRFCookie()
  }
})

export const getQueries = (state: Object) => state.queries
export const getEntities = (state: Object) => state.entities
